/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import FilterListIcon from "@material-ui/icons/FilterList";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Box from "@material-ui/core/Box";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Menu from "@material-ui/core/Menu";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles, makeStyles } from "@material-ui/core/styles";

import useAllStat from "../../../../../../hooks/useAllStat";
import Dialog from "@material-ui/core/Dialog";
import { Grid, Typography } from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import useTiers from "../../../../../../hooks/useTiers";
import useProducts from "../../../../../../hooks/useProducts";
import useCategories from "../../../../../../hooks/useCategories";
import useSubcategories from "../../../../../../hooks/useSubcategories";
const useStyles = makeStyles((theme) => ({
  FilterListIcon: {
    color: "#FFFFFF",
  },
  root: {
    textAlign: "right",
    paddingRight: theme.spacing(3),
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  ButtonGroup: {
    borderRadius: 50,
    textTransform: "none",
    color: "#FFFFFF",
    background: "#FA9917",
    marginRight: theme.spacing(2),
    width: 150,
    display: "grid",
    gridTemplateColumns: "120px 30px",
  },
  ButtonText: {
    border: "none",
    color: "white",
    textTransform: "none",
    height: 35,
    lineHeight: 1,
  },
  ButtonExit: {
    border: "none",
    borderLeftWidth: "2px",
    borderLeftStyle: "solid",
    borderLeftColor: "white",
    color: "white",
    padding: 0,
    paddingRight: 10,
    fontSize: "1rem",
  },
  MenuItem: {
    width: "120px",
  },
  GridContainer: {
    justifyContent: "space-around",
    padding: "10px",
  },
  ButtonNameCancle: {
    color: "#828282",
  },
  ButtonNameDone: {
    backgroundColor: "#FA9917",
    color: "white",
  },
  ButtonFillister: {
    borderRadius: 50,
    textTransform: "none",
    color: "#FFFFFF",
    background: "#FA9917",
    marginRight: "20px",
    "&:hover": {
      color: theme.white,
      backgroundColor: theme.orange + "!important",
    },
  },
  filterContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    height: 35,
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

export default function FilterList({
  filtersUsed,
  selectedFilter, //PeriodType
  onSetFilter,
  onSetDateRange,
  dateRange,
  filterList,
  selectedTier,
  setSelectedTier,
  selectedProduct,
  setSelectedProduct,
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory,
  selectedMemberType,
  setSelectedMemberType,
  selectedSortby,
  setSelectedSortby,
  selectedTierSortby,
  setSelectedTierSortby,
  selectedMemberSortby,
  setSelectedMemberSortby,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filter, setFilter] = useState(selectedFilter);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [calendarType, setCalendarType] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleClickFilter = (filterName, selected = null) => {
    switch (filterName) {
      case "Custom Date":
        setCalendarType("Custom Date");
        setOpenCalendar(true);
        return;
      case "Month":
        setCalendarType("Month");
        setOpenCalendar(true);
        return;
      case "Year":
        setCalendarType("Year");
        setOpenCalendar(true);
        return;
      case "Day":
        setCalendarType("Day");
        setOpenCalendar(true);
        return;
      case "All":
        setFilter(filterName);
        onSetFilter(filterName);
        return;
      default:
        break;
    }
  };

  const handleClickCalendarDone = (calendarType, dateRange) => {
    onSetDateRange(dateRange);
    setFilter(calendarType);
    onSetFilter(calendarType);
  };

  const formatDate = (d) => {
    let format = new Date(d).toDateString().split(" ");
    return `${format[2]} ${format[1]} ${format[3]}`;
  };

  if (!onSetFilter) {
    //Prevent mistake
    alert("No onSetFilter in Super Filter");
    return null;
  }

  return (
    <Box className={classes.filterContainer}>
      {filtersUsed?.find((f) => f === "calendar") &&
        (!filter ? (
          <Typography
            style={{
              fontWeight: "bolder",
              fontSize: "1rem",
              marginRight: 30,
              alignSelf: "center",
            }}
          >
            Today
          </Typography>
        ) : (
          filterList.map((filterName, index) => {
            return (
              filter === filterName && (
                <ButtonGroup
                  aria-label="outlined primary button group"
                  className={classes.ButtonGroup}
                  key={index}
                >
                  <Button className={classes.ButtonText}>
                    {filterName === "Custom Date"
                      ? `${formatDate(dateRange.startDate)} - ${formatDate(
                          dateRange.endDate
                        )}`
                      : filterName === "Day"
                      ? `${moment(dateRange.startDate).format("DD MMM YYYY")}`
                      : filterName === "Month"
                      ? `${moment(dateRange.startDate).format("MMM YYYY")}`
                      : filterName === "Year"
                      ? `${moment(dateRange.startDate).year()}`
                      : filterName === "All"
                      ? `All`
                      : filterName}
                  </Button>
                  <Button
                    className={classes.ButtonExit}
                    onClick={() => {
                      setFilter();
                      onSetFilter();
                    }}
                  >
                    x
                  </Button>
                </ButtonGroup>
              )
            );
          })
        ))}
      {filtersUsed.find((f) => f === "member") && (
        <MemberTypeSelector
          selectedMemberType={selectedMemberType}
          setSelectedMemberType={setSelectedMemberType}
        />
      )}
      {filtersUsed.find((f) => f === "tier") && (
        <TierSelector
          selectedTier={selectedTier}
          setSelectedTier={setSelectedTier}
        />
      )}
      {filtersUsed.find((f) => f === "product") && (
        <MostSaleProductSelector
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          dateRange={dateRange}
          selectedFilter={selectedFilter}
        />
      )}
      {filtersUsed.find((f) => f === "category") && (
        <MostSaleCategorySelector
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          dateRange={dateRange}
          selectedFilter={selectedFilter}
        />
      )}
      {filtersUsed.find((f) => f === "subcategory") && (
        <MostSaleSubcategorySelector
          selectedSubcategory={selectedSubcategory}
          setSelectedSubcategory={setSelectedSubcategory}
          dateRange={dateRange}
          selectedFilter={selectedFilter}
        />
      )}
      {filtersUsed.find((f) => f === "sortby") && (
        <SortbySelector
          selectedSortby={selectedSortby}
          setSelectedSortby={setSelectedSortby}
        />
      )}
      {filtersUsed.find((f) => f === "tiersortby") && (
        <TierSortbySelector
          selectedTierSortby={selectedTierSortby}
          setSelectedTierSortby={setSelectedTierSortby}
        />
      )}
      {filtersUsed.find((f) => f === "memberSortby") && (
        <MemberSortbySelector
          selectedMemberSortby={selectedMemberSortby}
          setSelectedMemberSortby={setSelectedMemberSortby}
        />
      )}
      {filtersUsed.find((f) => f === "calendar") && (
        <Button
          aria-controls="customized-menu"
          aria-haspopup="true"
          variant="contained"
          onClick={handleClick}
          className={classes.ButtonFillister}
        >
          <FilterListIcon className={classes.FilterListIcon}></FilterListIcon>
          Filter
        </Button>
      )}
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {filterList.map((filterName, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => {
                handleClickFilter(filterName);
                setAnchorEl(null);
              }}
            >
              <ListItemText primary={filterName} />
            </MenuItem>
          );
        })}
      </StyledMenu>
      <Dialog
        local="th"
        open={openCalendar}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            borderRadius: 12,
          },
        }}
      >
        {calendarType === "Month" && (
          <DatePicker
            inline
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            maxDate={new Date()}
            style={{ borderRadius: 12 }}
          />
        )}
        {calendarType === "Year" && (
          <DatePicker
            inline
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showYearPicker
            dateFormat="yyyy"
            maxDate={new Date()}
          />
        )}
        {calendarType === "Day" && (
          <DatePicker
            inline
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            maxDate={new Date()}
          />
        )}
        {calendarType === "Custom Date" && (
          <DatePicker
            inline
            selected={startDate}
            onChange={onDateChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            maxDate={new Date()}
          />
        )}

        <Grid container className={classes.GridContainer}>
          <Button
            onClick={() => {
              setOpenCalendar(false);
            }}
            className={classes.ButtonNameCancle}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleClickCalendarDone(calendarType, {
                startDate: moment(startDate),
                endDate: moment(endDate),
                key: "selection",
              });
            }}
            className={classes.ButtonNameDone}
            disabled={!endDate && calendarType === "Custom Date"}
          >
            Done
          </Button>
        </Grid>
      </Dialog>
    </Box>
  );
}

const TierSelector = ({ selectedTier, setSelectedTier }) => {
  const { tiers, loading, error } = useTiers();
  if (loading) return null;
  if (error) return null;
  return (
    <Select
      style={{
        minWidth: "10ch",
        margin: "0 5px 0 5px",
        justifyContent: "flex-end",
      }}
      defaultValue="All"
      value={selectedTier}
      onChange={(e, value) => setSelectedTier(e.target.value)}
      variant="outlined"
    >
      <MenuItem value="All">All Tiers</MenuItem>
      {tiers.map((tier) => {
        return <MenuItem value={tier.name}>{tier.name}</MenuItem>;
      })}
    </Select>
  );
};

const MostSaleProductSelector = ({
  selectedProduct,
  setSelectedProduct,
  selectedFilter,
  dateRange,
}) => {
  const [loading, setLoading] = useState(true);
  const { getProducts } = useAllStat();
  const [defaultProduct, setDefaultProduct] = useState();
  useEffect(() => {
    async function loadProduct() {
      const { fromDate, toDate, periodType } = getFromDatetoDateandPeriodType({
        selectedFilter,
        dateRange,
      });
      const [productStat] = await getProducts({
        fromDate,
        toDate,
        periodType,
      });
      //find max rev

      const maxProduct =
        productStat?.reduce(
          (max, curr) => {
            if (curr?.payment?.total_revenue >= max.productRev) {
              return {
                productId: curr.product_id,
                productName: curr.name,
                productRev: curr.payment?.total_revenue,
              };
            } else return { ...max };
          },
          { productId: null, productName: null, productRev: 0 }
        ) ?? {};
      setDefaultProduct(maxProduct.productId);
      setSelectedProduct(maxProduct.productId);
      setLoading(false);
    }
    if (!selectedProduct) loadProduct();
    else setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) return <Typography>Loading</Typography>;
  return (
    <ProductSelector
      selectedProduct={selectedProduct}
      setSelectedProduct={setSelectedProduct}
      defaultProductId={defaultProduct}
    />
  );
};

const getFromDatetoDateandPeriodType = ({ dateRange, selectedFilter }) => {
  let fromDate, toDate, periodType;
  if (!selectedFilter) {
    fromDate = moment().format("YYYY-MM-DD");
    toDate = fromDate;
    periodType = "Day";
  }
  if (selectedFilter === "All") {
    fromDate = "2020-01-01";
    toDate = moment().format("YYYY-MM-DD");
    periodType = "All";
  }
  if (selectedFilter === "Day") {
    fromDate = moment(dateRange.startDate).format("YYYY-MM-DD");
    toDate = moment(dateRange.startDate).format("YYYY-MM-DD");
    periodType = "Day";
  }
  if (selectedFilter === "Month") {
    fromDate = moment(dateRange.startDate)
      .startOf("Month")
      .format("YYYY-MM-DD");
    toDate = moment(dateRange.startDate).endOf("Month").format("YYYY-MM-DD");

    periodType = "Month";
  }
  if (selectedFilter === "Year") {
    fromDate = moment(dateRange.startDate).format("YYYY-01-01");
    toDate = moment(dateRange.startDate).format("YYYY-12-31");
    periodType = "Year";
  }
  return { fromDate, toDate, periodType };
};

const ProductSelector = ({
  selectedProduct,
  setSelectedProduct,
  defaultProductId,
}) => {
  const { products, error, loading } = useProducts();
  if (loading) return null;
  if (error) return null;

  return (
    <Select
      style={{
        minWidth: "10ch",
        margin: "0 5px 0 5px",
        height: 35,
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedProduct(e.target.value)}
      value={selectedProduct}
      variant="outlined"
      defaultValue={defaultProductId ? defaultProductId : "select"}
    >
      <MenuItem value="select">Select one</MenuItem>;
      {products.map((product) => {
        return <MenuItem value={product.id}>{product.name}</MenuItem>;
      })}
    </Select>
  );
};

const MostSaleCategorySelector = ({
  selectedCategory,
  setSelectedCategory,
  selectedFilter,
  dateRange,
}) => {
  const [loading, setLoading] = useState(true);
  const { getCategory } = useAllStat();
  const [defaultCat, setDefaultCat] = useState();
  useEffect(() => {
    async function loadCat() {
      const { fromDate, toDate, periodType } = getFromDatetoDateandPeriodType({
        selectedFilter,
        dateRange,
      });
      const [catStat] = await getCategory({
        fromDate,
        toDate,
        periodType,
      });
      //find max rev

      const max =
        catStat?.reduce(
          (max, curr) => {
            if (curr?.payment?.total_revenue >= max.categoryRev) {
              return {
                categoryId: curr.product_category_id,
                categoryName: curr.name,
                categoryRev: curr.payment?.total_revenue,
              };
            } else return { ...max };
          },
          { categoryId: null, categoryName: null, categoryRev: 0 }
        ) ?? {};

      setDefaultCat(max.categoryId);
      setSelectedCategory(max.categoryId);
      setLoading(false);
    }
    if (!selectedCategory) loadCat();
    else setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) return <Typography>Loading</Typography>;
  return (
    <CategorySelector
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      defaultCatId={defaultCat}
    />
  );
};

const CategorySelector = ({
  selectedCategory,
  setSelectedCategory,
  defaultCatId,
}) => {
  const { categories, error, loading } = useCategories();
  if (loading) return null;
  if (error) return null;

  return (
    <Select
      style={{
        minWidth: "10ch",
        margin: "0 5px 0 5px",
        height: 35,
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedCategory(e.target.value)}
      value={selectedCategory}
      variant="outlined"
      defaultValue={defaultCatId ? defaultCatId : "select"}
    >
      <MenuItem key="selectone" value="select">
        Select one
      </MenuItem>
      ;
      {categories.map((cat, index) => {
        return (
          <MenuItem key={index} value={cat.id}>
            {cat.name}
          </MenuItem>
        );
      })}
    </Select>
  );
};

const MostSaleSubcategorySelector = ({
  selectedSubcategory,
  setSelectedSubcategory,
  selectedFilter,
  dateRange,
}) => {
  const [loading, setLoading] = useState(true);
  const { getSubcategory } = useAllStat();
  const [defaultSubcat, setDefaultSubcat] = useState();
  useEffect(() => {
    async function loadSubcat() {
      const { fromDate, toDate, periodType } = getFromDatetoDateandPeriodType({
        selectedFilter,
        dateRange,
      });
      const [catStat] = await getSubcategory({
        fromDate,
        toDate,
        periodType,
      });
      //find max rev

      const max =
        catStat?.reduce(
          (max, curr) => {
            if (
              curr?.payment?.total_revenue >= max.subcategoryRev &&
              curr.product_sub_category_id
            ) {
              return {
                subcategoryId: curr.product_sub_category_id,
                subcategoryName: curr.name,
                subcategoryRev: curr.payment?.total_revenue,
              };
            } else return { ...max };
          },
          {
            subcategoryId: null,
            subcategoryName: null,
            subcategoryRev: 0,
          }
        ) ?? {};

      setDefaultSubcat(max.subcategoryId);
      setSelectedSubcategory(max.subcategoryId);
      setLoading(false);
    }
    if (!selectedSubcategory) loadSubcat();
    else setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (loading) return <Typography>Loading</Typography>;
  return (
    <SubcategorySelector
      selectedSubcategory={selectedSubcategory}
      setSelectedSubcategory={setSelectedSubcategory}
      defaultSubcatId={defaultSubcat}
    />
  );
};

const SubcategorySelector = ({
  selectedSubcategory,
  setSelectedSubcategory,
  defaultSubcatId,
}) => {
  const { subcategories, error, loading } = useSubcategories();
  if (loading) return null;
  if (error) return null;

  return (
    <Select
      style={{
        minWidth: "10ch",
        margin: "0 5px 0 5px",
        height: 35,
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedSubcategory(e.target.value)}
      value={selectedSubcategory}
      variant="outlined"
      defaultValue={defaultSubcatId ? defaultSubcatId : "select"}
    >
      <MenuItem value="select">Select one</MenuItem>;
      {subcategories.map((cat) => {
        return (
          <MenuItem
            value={cat.id}
          >{`${cat.name} (${cat.category?.name})`}</MenuItem>
        );
      })}
    </Select>
  );
};

const MemberTypeSelector = ({ selectedMemberType, setSelectedMemberType }) => {
  return (
    <Select
      style={{
        minWidth: "18ch",
        margin: "0 5px 0 5px",
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedMemberType(e.target.value)}
      value={selectedMemberType}
      variant="outlined"
      defaultValue="select"
    >
      <MenuItem value="all">All Customer</MenuItem>
      <MenuItem value="member">Member</MenuItem>;
      <MenuItem value="guest">Walk-in</MenuItem>;
    </Select>
  );
};

const SortbySelector = ({ selectedSortby, setSelectedSortby }) => {
  return (
    <Select
      style={{
        minWidth: "15ch",
        margin: "0 5px 0 5px",
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedSortby(e.target.value)}
      value={selectedSortby}
      variant="outlined"
      defaultValue="select"
      label="Sort by"
    >
      <MenuItem value="price">Sort by Price</MenuItem>
      <MenuItem value="qty">Sort by QTY</MenuItem>;
    </Select>
  );
};

const TierSortbySelector = ({ selectedTierSortby, setSelectedTierSortby }) => {
  return (
    <Select
      style={{
        minWidth: "15ch",
        margin: "0 5px 0 5px",
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedTierSortby(e.target.value)}
      value={selectedTierSortby}
      variant="outlined"
      defaultValue="select"
      label="Sort by"
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="ltv">Top LTV</MenuItem>
      <MenuItem value="bigspender">Top Big Spender</MenuItem>
    </Select>
  );
};

const MemberSortbySelector = ({
  selectedMemberSortby,
  setSelectedMemberSortby,
}) => {
  return (
    <Select
      style={{
        minWidth: "15ch",
        margin: "0 5px 0 5px",
        justifyContent: "flex-end",
      }}
      onChange={(e) => setSelectedMemberSortby(e.target.value)}
      value={selectedMemberSortby}
      variant="outlined"
      defaultValue=""
      label="Sort by"
    >
      <MenuItem value="member">Member</MenuItem>
      <MenuItem value="item">Item</MenuItem>
      <MenuItem value="revenue">Revenue</MenuItem>
    </Select>
  );
};
